module.exports = __webpack_public_path__ + "static/media/cart.c4352e11.svg";